import type { GridColumnsManagementProps } from '@mui/x-data-grid';

/**
 * Default `columnsManagement` slotProps for MUI Data Grid (Community & Pro).
 *
 * Restricts the columns panel to only columns where `hideable` is not
 * explicitly set to `false`, which prevents locked/internal columns from
 * appearing as toggleable options.
 *
 * Assign directly to `slotProps.columnsManagement`, or spread it when you
 * need to add extra options for a specific grid.
 *
 * @example Basic usage
 * ```tsx
 * <DataGridPro slotProps={{ columnsManagement: defaultColumnsManagementSlotProps }} />
 * ```
 *
 * @example Extending for a special case
 * ```tsx
 * <DataGridPro
 *   slotProps={{
 *     columnsManagement: {
 *       ...defaultColumnsManagementSlotProps,
 *       sort: 'asc',
 *     },
 *   }}
 * />
 * ```
 */
export const defaultColumnsManagementSlotProps: GridColumnsManagementProps = {
  getTogglableColumns: (columns) =>
    columns.filter((col) => col.hideable !== false).map((col) => col.field),
  // MUI X v8's internal TextFieldProps omits `variant` from its type definition,
  // but the prop is forwarded to the underlying MUI TextField at runtime.
  // To maintain our existing display
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  searchInputProps: { variant: 'outlined' } as any,
};
